import { css } from '@emotion/react';
import { Trans, useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { Text } from '@frontend/design-system';

export function CompletionBanner() {
  const { t } = useTranslation('call-intel-onboarding');

  return (
    <div css={styles.banner}>
      <Text weight='bold' textAlign='center' size='medium'>
        <Trans t={t}>
          🎉 You’re ready to start conquering{' '}
          <Text as='span' textAlign='center' size='medium' css={styles.nowrap}>
            Call Intelligence!
          </Text>
        </Trans>
      </Text>
    </div>
  );
}

const styles = {
  banner: css`
    padding: ${theme.spacing(1, 1.5)};
    border: 1px solid ${theme.colors.secondary.seaweed50};
    border-radius: ${theme.borderRadius.small};
    box-shadow: ${theme.shadows.light};
  `,
  nowrap: css`
    white-space: nowrap;
  `,
};
